// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"652dd2b88f76a351ba56","453":"b31ee1ba9fcb26cf14c7","503":"80bf6cbf15447a7288bb"}[chunkId] + ".js";
};